<template>
  <div class="modalUser">
    <b-modal id="modalAddEmployee" ref="modalAddEmployee" centered size="lg" modal-class="modal-no-border modal-radius top-mb" no-close-on-backdrop >
      <template v-slot:modal-header="{close}">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <h2 class="title">社員追加</h2>
          <div class="btn-closeModal" @click="closeModal">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
          <div class="avatar">
            <img v-if="params.avatar" :src="params.avatar" alt class="avt-modal" ref="displayImage"/>
            <img v-else src="@img/avt-exp.svg" alt class="avt-modal" ref="displayImage"/>
            <div class="input-upload">
              <label for="uploadfile" class="label-upload"></label>
              <input type="file" id="uploadfile" name="uploadfile" class="btn-file input-0" accept=".jpg, .png, .bmp, .gif, .jpeg"  @change="changeImage($event)"/>
            </div>
          </div>
          <ModalErrorUploadImage @hidePopupImage="hidePopupImage" :avatarError="avatarError"/>
        </div>
      </template>
      <div class="modalUser--main popup-scrollable scroll-bar">
        <form action="" class="formDetailUser">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label for="userId" class="label-form">社員コード</label>
                <div class="input-group">
                  <input type="text" id="userId" name="userId" class="input-form" placeholder="IDを入力してください" v-model="params.employee_code">
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="userName" class="label-form">お名前<span class="required">*</span></label>
                <div class="input-group">
                  <input type="text" id="userName" name="userName" class="input-form" v-model="params.name" :class="{error:!$v.params.name.required && invalid}" @input="$v.params.name.$touch()" placeholder="名前を入力してください">
                  <small v-if="!$v.params.name.required && invalid" class="text-input error">{{message.NAME_REQUIRED}}</small>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="department" class="label-form">所属</label>
                <div class="input-group">
                  <input type="text" id="department" name="department" class="input-form" placeholder="所属を入力してください" v-model="params.position">
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="phone" class="label-form">電話番号</label>
                <div class="input-group">
                  <input type="tel" id="phone" name="phone" class="input-form" placeholder="電話番号を入力してください" v-model="params.phone" :class="{error: !$v.params.phone.valid && invalid}" @input="$v.params.phone.$touch()">
                  <small v-if="!$v.params.phone.valid && invalid" class="text-input error">{{message.PHONE_FORMAT}}</small>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="email" class="label-form">メールアドレス<span class="required">*</span></label>
                <div class="input-group">
                  <input type="email" id="email" name="email" class="input-form" placeholder="メールアドレスを入力してください" v-model.trim="params.email" :class="emailFormat()" @input="$v.params.email.$touch()">
                  <small v-if="!$v.params.email.required && invalid" class="text-input error">{{message.EMAIL_REQUIRED}}</small>
                  <small v-if="!$v.params.email.valid && invalid && $v.params.email.required" class="text-input error">{{message.EMAIL_FORMAT}}</small>
                  <small v-if="errorMessage.email" class="text-input error">{{emailError(errorMessage.email[0])}}</small>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="password" class="label-form">パスワード<span class="required">*</span></label>
                <div class="input-group">
                  <input :type="passwordFieldType" id="password" name="password" class="input-form" placeholder="パスワードを入力してください" v-model="params.password" :class="passwordError()" @input="$v.params.password.$touch()">
                  <small v-if="!$v.params.password.required && invalid" class="text-input error">{{message.PASSWORD_REQUIRED}}</small>
                  <small v-if="passwordError()" class="text-input error">{{message.PASSWORD_FORMAT}}</small>
                  <button class="btn-showPass" @click.prevent="showHidePass" :class="{ show: showPass }">
                    <i class="icon-i-eyes-01"></i>
                  </button>
                  <div class="px-2 py-2 mt-2">
                     <ul class="list-inside">
                      <li>
                        <svg v-if="!containsUppercase || !containsLowercase || !containsNumber" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="red" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="green" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                        </svg>
                        大文字、小文字、数字を使用してください。
                      </li>
                      <li>
                        <svg v-if="!containsSpecial" xmlns="http://www.w3.org/2000/svg"  width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="red" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="green" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                        </svg>
                          少なくとも１つ以上の特殊文字（#?!@$%^&*- ）を使用してください
                      </li>
                      <li>
                        <svg v-if="passwordLength <= 7" xmlns="http://www.w3.org/2000/svg"  width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="red" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="green" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                        </svg>
                        8文字以上で作成してください。
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="label-form">ロール</label>
                <div class="input-group">
                  <b-form-select  class="select select-dropdown input-form" v-model="params.role_id" :class="{error: !$v.params.role_id.required && invalid}">
                    <b-form-select-option v-for="role in roles" v-bind:key="role.id" :value="role.id">{{convertName(role.name)}}</b-form-select-option>
                  </b-form-select>
                </div>
                <div class="input-group" v-if="!$v.params.role_id.required && invalid">
                  <small class="text-input error">{{message.ROLE_REQUIRED}}</small>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 d-none d-lg-block">
          <div class="button-group">
            <button
              class="btn btn-rounder btn-second btn-cancel"
              type="button"
              @click="closeModal"
            >キャンセル</button>
            <button
              class="btn btn-rounder btn-primary btn-login ml-30"
              type="button"
              @click="addEmployee"
            >追加</button>
          </div>
        </div>
        <div class=" d-block d-lg-none">
          <div class="d-flex justify-content-center flex-wrap admin-vendor-btnGroup">
            <button class="btn btn-primary btn-rounder" type="button"  @click="addEmployee">追加</button>
            <button class="btn btn-secondary btn-rounder btn-space" type="button" @click="closeModal">キャンセル</button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import {mapState} from 'vuex'
import {MESSAGE} from '@/utils/errorjapanese'
import errorMessage from '@/utils/errormessage'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import ModalErrorUploadImage from '@/components/share/ErrorUploadImage'
export default {
  name: 'Add_Employee',
  data () {
    return {
      passwordFieldType: 'password',
      params: {
        avatar: '',
        employee_code: '',
        name: '',
        position: '',
        phone: '',
        email: '',
        password: '',
        role_id: ''
      },
      avatarError: '',
      message: MESSAGE,
      invalid: false,
      containsUppercase: null,
      containsLowercase: null,
      containsNumber: null,
      containsSpecial: null,
      passwordLength: 0,
      nameautocomplete: false,
      passwordautocomplete: false,
      emailautocomplete: false
    }
  },
  watch: {
    'params.email' () {
      this.$store.commit('adminEmployee/CHANGE_MESSAGE_ERROR', '')
      if (!this.emailautocomplete) {
        this.params.email = null
        this.emailautocomplete = true
      }
    },
    'params.name' () {
      if (!this.nameautocomplete) {
        this.params.name = null
        this.nameautocomplete = true
      }
    },
    'params.password' () {
      if (!this.passwordautocomplete) {
        this.params.password = ''
        this.passwordautocomplete = true
      }
    }
  },
  validations: {
    params: {
      name: {
        required
      },
      email: {
        required,
        valid (email) {
          const validate = /^[[a-zA-Z][a-zA-Z0-9_.-]{1,32}@[a-z0-9_-]{2,}(\.[a-z0-9]{2,}){1,}$/.test(email)
          return validate
        }
      },
      phone: {
        valid (phone) {
          if (phone) {
            const validate = /^[0-9-.+]{3,20}$/i.test(phone)
            return validate
          }
          return true
        }
      },
      role_id: {
        required
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
        valid (password) {
          this.containsUppercase = /[A-Z]/.test(password)
          this.containsLowercase = /[a-z]/.test(password)
          this.containsNumber = /[0-9]/.test(password)
          this.containsSpecial = /[#?!@$%^&*-]/.test(password)
          this.passwordLength = password.length
          console.log(this.containsUppercase)
          return this.containsUppercase && this.containsLowercase && this.containsNumber && this.containsSpecial && this.passwordLength
        }
      }
    }
  },
  methods: {
    convertName (value) {
      if (value === 'employee') {
        return '社員'
      }
      if (value === 'manager') {
        return '管理者'
      }
    },
    emailFormat () {
      return ((!this.$v.params.email.valid || !this.$v.params.email.required) && this.invalid) || this.errorMessage.email ? 'error' : ''
    },
    hidePopupImage () {
      this.avatarError = ''
      this.$root.$emit('bv::hide::modal', 'modalErrorUploadImage', '#modalErrorUploadImage')
    },
    closeModal () {
      this.invalid = false
      this.$store.commit('adminEmployee/CHANGE_MESSAGE_ERROR', '')
      this.params.avatar = ''
      this.params.employee_code = ''
      this.params.position = ''
      this.params.name = ''
      this.params.phone = ''
      this.params.email = ''
      this.params.password = ''
      this.params.role_id = ''
      this.$refs['modalAddEmployee'].hide()
    },
    passwordError () {
      return (!this.$v.params.password.minLength || !this.$v.params.password.maxLength || !this.$v.params.password.valid) && this.invalid && this.$v.params.password.required
    },
    passwordErrorFormat () {
      return (!this.$v.params.password.minLength || !this.$v.params.password.maxLength || !this.$v.params.password.valid) && this.invalid ? 'error' : ''
    },
    changeImage (e) {
      e.preventDefault()
      if (/\.(jpg|jpeg|png|bmp|gif)$/.test(e.target.files[0].name) && e.target.files[0].size <= 5242880) {
        this.params.avatar = e.target.files[0]
        let reader = new FileReader()
        reader.addEventListener('load', function () {
          this.$refs.displayImage.src = reader.result
        }.bind(this), false)
        reader.readAsDataURL(this.params.avatar)
      } else {
        e.target.value = ''
        this.avatarError = MESSAGE.AVATAR_FORMAT
        this.$root.$emit('bv::show::modal', 'modalErrorUploadImage', '#modalErrorUploadImage')
      }
    },
    emailError (value) {
      return errorMessage.errorEmail(value)
    },
    clearParams () {
      this.params.avatar = ''
      this.params.employee_code = ''
      this.params.name = ''
      this.params.position = ''
      this.params.phone = ''
      this.params.email = ''
      this.params.password = ''
      this.params.role_id = ''
    },
    addEmployee (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      const companyId = this.$route.params.id
      const formData = new FormData()
      if (this.params.avatar) {
        formData.append('avatar', this.params.avatar)
      }
      formData.append('name', this.params.name)
      formData.append('employee_code', this.params.employee_code)
      if (this.params.position) {
        formData.append('position', this.params.position)
      }
      formData.append('phone', this.params.phone)
      formData.append('email', this.params.email)
      formData.append('password', this.params.password)
      formData.append('role_id', this.params.role_id)
      formData.append('company_id', companyId)
      this.$store.dispatch('adminEmployee/addEmployee', { formData, modal: this.$refs['modalAddEmployee'], clearParams: this.clearParams, id: companyId })
    }
  },
  components: {
    'b-modal': BModal,
    ModalErrorUploadImage
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  mounted () {
    this.$store.dispatch('adminEmployee/getRole')
  },
  computed: {
    ...mapState({
      roles: state => state.adminEmployee.roles,
      errorMessage: state => state.adminEmployee.errorMessage
    })
  }
}
</script>
<style scoped lang="scss">
  .btn-space {
    margin-top: 10px;
    margin-bottom: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Employee/Add.vue